import { z } from 'zod';

import { metricRangeSchema, metricsSchema } from '@/schemas/commons';
import type { ZodUseQuery } from '@/utils/zodReactQuery';

export const metricsResponse = metricsSchema;
export const metricsParams = z.object({
	range: metricRangeSchema,
	moduleName: z.string().optional(),
});

export type MetricsResponse = z.infer<typeof metricsResponse>;
export type MetricsParams = z.infer<typeof metricsParams>;
export type UseMetrics = ZodUseQuery<MetricsResponse, MetricsParams>;
